import api from "PFCore/api";
import { Id } from "PFTypes";

export const deleteMarketplaceSaved = (id: Id) =>
  api({
    url: `marketplace/saved/${id}`,
    method: "DELETE"
  });
